import axios from "axios";
import { toast } from "react-toastify";
export const GetAllProject = (data) => {
  return {
    type: "get_allproject",
    payload: data,
    loader: false,
  };
};
export function getallProject() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Projects/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllProject(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
